import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import getByPath from 'lodash/get'

import ConversationList from './ConversationList'

import CONVERSATIONS_BY_USER from './../../graphql/Chat/ConversationsByUser.graphql'
import MESSAGE_SUBSCRIPTION from './../../graphql/Chat/MessageSubscription.graphql'
import CREATE_MESSAGE from './../../graphql/Chat/CreateMessage.graphql'
import UPDATE_MESSAGE from './../../graphql/Chat/UpdateMessage.graphql'

class Chat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedConversation: '',
      unreadMessages: []
    }
  }

  componentWillMount() {
    this.props.data.subscribeToMore({
      document: MESSAGE_SUBSCRIPTION,
      updateQuery: (previousState, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return previousState
        } else {
          this.props.data.refetch().then(() => {
            const newMessage = getByPath(subscriptionData, 'data.Message.node')

            if (!newMessage) return

            if (newMessage.sender.id !== this.props.user.id && !this.props.displayChat) {
              this.audio.play()
            }

            if (this.state.selectedConversation.id == subscriptionData.data.Message.node.conversation.id) {
              const selectedConversation = {
                ...this.state.selectedConversation
              }
              const newMessages = [...this.state.selectedConversation.messages]

              const message = this.state.selectedConversation.messages.map(msg => msg.id).find(msg => msg.id === newMessage.id)

              if (newMessage.conversation.id === this.state.selectedConversation.id && !message) {
                newMessages.push(newMessage)
                selectedConversation.messages = newMessages

                this.setState({ selectedConversation })
              }
            }
          })
        }
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      this.props.data.refetch()
    }

    if (nextProps.data.chatOnTop) {
      this.setState({
        displayChat: true
      })
    }
  }

  updateParentState = state => {
    this.setState(state)
  }

  componentDidUpdate() {
    if (this.props.data) {
      this.props.data.refetch()
    }
  }

  render() {
    const { user, displayChat, showChatBox } = this.props
    const isDisplayed = displayChat ? 'chat-box' : 'hidden'
    const isOnTop = this.props.chatOnTop ? 'chat-on-top' : ''
    const classes = `${isDisplayed} ${isOnTop}`

    let newMessages = []

    if (this.props.data.allConversations) {
      this.props.data.allConversations.forEach(conversation => {
        newMessages = newMessages.concat(conversation.messages).filter(msg => {
          return msg.status === 'Unread' && msg.sender.id !== user.id
        })
      })
    }

    let className = newMessages.length ? 'notification-msg' : ''
    let navbarClass = this.props.notificationInNavbar ? '' : 'menu-not-shown'

    return (
      <div className="chat-wrapper">
        <audio
          id="audio"
          ref={audio => {
            this.audio = audio
          }}
          src="http://www.soundjay.com/button/beep-07.wav"
        />
        <span className={className + ' ' + navbarClass} />
        <div className={classes}>
          <ConversationList
            user={user}
            updateParentState={this.updateParentState}
            showChatBox={showChatBox}
            conversations={this.props.data.allConversations}
            selectedConversation={this.state.selectedConversation}
          />
        </div>
        <button
          className="chat-bubble"
          id="chat-bubble"
          onClick={() => {
            showChatBox()
          }}
        >
          <i className={displayChat ? 'icon-close' : 'hidden'} id="chat-close" />
          <img className={displayChat ? 'hidden' : ''} src="/img/message-icon.svg" id="chat-open" />
        </button>
      </div>
    )
  }
}

export default compose(
  graphql(CREATE_MESSAGE, {
    name: 'createMessage'
  }),
  graphql(UPDATE_MESSAGE, {
    name: 'updateMessage'
  }),
  graphql(CONVERSATIONS_BY_USER, {
    options: props => ({
      variables: {
        userId: props.user ? props.user.id : ''
      },
      fetchPolicy: 'network-only'
    })
  })
)(Chat)



// WEBPACK FOOTER //
// src/components/Chat/index.jsx